
<template>
  <div class="page__container">
    <BreadCrumbsTemplate />
    <AboutTemplate />
  </div>
</template>

<script>
import AboutTemplate from '@/components/AboutTemplate.vue';
import BreadCrumbsTemplate from '@/components/BreadCrumbsTemplate.vue';

export default {
  name: 'AboutView',
  components: {
    AboutTemplate,
    BreadCrumbsTemplate
  },
};
</script>

